module.exports = __webpack_public_path__ + "media/assets/faria_products/POC-IGCSE-725fae0e748dabcb62697f7f81b0cf35a3f491bd6835dbc42350dc2f3f6a9e2b.png";